import { FC } from 'react';
import Line from './Line';

interface iLinesProps {
  value: any;
  margin: number;
  support: string;
  isOn: boolean;
  sizeModified: number;
  weight: string;
  scale: number;
}
const Lines: FC<iLinesProps> = ({ value, ...rest }) => {
  return (
    <>
      {value
        .filter((line: any) => line.children?.[0]?.text?.length > 0)
        .map(({ children }: any, i: number) => (
          <Line i={i} content={children} {...rest} value={value} key={`line-${i}`} />
        ))}
    </>
  );
};

export default Lines;
